import { InternalAxiosRequestConfig } from "axios";

export const queryInterceptor = (config: InternalAxiosRequestConfig) => {
  // Remove parâmetros vazios/nulos
  if (config.params) {
    config.params = Object.fromEntries(
      Object.entries(config.params).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
    );
  }

  return config;
};
